/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthResponseDto } from '../../models/auth-response-dto';

export interface AuthExternalCallbackGet$Plain$Params {
  provider?: string;
  returnUrl?: string;
}

export function authExternalCallbackGet$Plain(http: HttpClient, rootUrl: string, params?: AuthExternalCallbackGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
  const rb = new RequestBuilder(rootUrl, authExternalCallbackGet$Plain.PATH, 'get');
  if (params) {
    rb.query('provider', params.provider, {});
    rb.query('returnUrl', params.returnUrl, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthResponseDto>;
    })
  );
}

authExternalCallbackGet$Plain.PATH = '/auth/external/callback';
